import { CadabraService } from './cadabraService';
import { Observable } from '../helpers/observable';
import { SnackbarService } from './snackbarService';

export const initialDataLoaded = new Observable<boolean>(false);
export const cadabraService = new CadabraService();
export const snackbarService = new SnackbarService();
